import { Exclude, Expose, Type } from 'class-transformer';
import { ApiProperty } from '@nestjs/swagger';
import { IsBoolean } from 'class-validator';
import { ModelBoardSheetInterface } from '../interfaces/model-board-sheet.interface';
import { RegionDto } from '../../region/dto/region.dto';

@Exclude()
export class ModelBoardSheetDto implements ModelBoardSheetInterface {
  @ApiProperty({
    title: 'Job ID (synonym for React Admin only)',
  })
  @Expose()
  id!: string;

  @ApiProperty({
    title: 'Model ID',
    description: 'The model number/identifier',
  })
  @Expose()
  modelId!: string;

  @ApiProperty({
    title: 'Model Name',
    description: 'The model name',
  })
  @Expose()
  modelName!: string;

  @ApiProperty({
    title: 'Subdivision ID',
    description: 'The subdivision number/identifier',
  })
  @Expose()
  subdivisionId!: string;

  @ApiProperty({
    title: 'Subdivision Name',
    description: 'The subdivision name',
  })
  @Expose()
  subdivisionName!: string;

  @ApiProperty({
    title: 'Builder ID',
    description: 'The builder number/identifier',
  })
  @Expose()
  builderId!: string;

  @ApiProperty({
    title: 'Builder Name',
    description: 'The builder name',
  })
  @Expose()
  builderName!: string;

  @ApiProperty({
    type: 'date-time',
    title: 'Created At',
  })
  @Expose()
  @Type(() => Date)
  createdAt!: Date;

  @ApiProperty({
    type: 'date-time',
    title: 'Updated At',
  })
  @Expose()
  @Type(() => Date)
  updatedAt!: Date;

  //
  // Subdivision fields
  //

  @ApiProperty({
    title: "Supervisor's Field Coordinator User Id",
  })
  @Expose()
  supervisorFieldCoordinatorUserId!: string;

  @ApiProperty({
    title: 'Supervisor User ID',
  })
  @Expose()
  supervisorUserIds!: string;

  @ApiProperty({
    title: 'Supervisor Full Name',
  })
  @Expose()
  supervisorFullNames!: string;

  @ApiProperty({
    title: 'Region Id',
  })
  @Expose()
  regionId!: string;

  @ApiProperty({
    title: 'Labor Only?',
    description: 'The model is for labor only.',
    default: false,
  })
  @IsBoolean()
  @Expose()
  laborOnly!: boolean;

  @ApiProperty({
    type: () => [RegionDto],
    title: 'Associated Regions',
    description: 'The regions associated with this model',
  })
  @Expose()
  region!: RegionDto;
}
